<!--loading-->
<div *ngIf="!Addons && !notFound">
  <app-inner-loading></app-inner-loading>
</div>
<!--End collection__spinner-->
<div class="container" *ngIf="notFound">
  <div class="empty-div">
    <p>
      {{language['sorrySomethingWentWrong']}}
    </p>
  </div>
  <div class="text-center">
    <button routerLink="/collection" class="custom-btn">{{language['backToCollection']}}</button>
  </div>
</div>
<!--style product details-->
<section class="singleProduct" *ngIf="Addons">
  <div class="container">
    <div class="row">
      <!--start image gallery-->
      <div class="col-lg-5">
        <div class="gallery">
          <carousel *ngIf="(Addons[0].images?.length > 0);" [interval]="false">
            <slide *ngFor="let image of Addons[0].images" class="main-image-product">
              <div class="easyzoom easyzoom--overlay easyzoom--with-thumbnails" style="width:100%">
                <a [href]="imageUrl + image.path" class="image-wrapper">
                  <img #thisImage (error)="thisImage.src = defaultImage" [alt]="product.name"
                    [src]="imageUrl + image.path" class="animate-fade"
                    (load)="handleEasyZoom(); imgIsLoaded = true" [hidden]="!imgIsLoaded">
                </a>
              </div>
            </slide>
          </carousel>
        
        
          <ng-template #displayImage>
            <div class="easyzoom--with-thumbnails">
              <img [alt]="product.name" [lazyLoad]="defaultImage" class="img-fluid" style="width: 100%">
            </div>
          </ng-template>
        
          <owl-carousel [options]="changeCarouselOptions(thumbnialOptions)" [carouselClasses]="['owl-theme', 'owl-flex']">
            <div class="imgSlide thumbnails" *ngFor="let image of Addons[0].images">
              <a [href]="imageUrl + image.path">
                <img [lazyLoad]="imageUrl + image.path" [alt]="product.name" #thisImage (error)="thisImage.src = defaultImage">
              </a>
            </div>
          </owl-carousel>
        </div>
        
      </div><!--End COl-->
      <!--start product info-->
      <div class="col-lg-7">
        <div class="product-details-content">
          <h4 class="title" id="dialog-child-name">
            <a class="product-title"
              [routerLink]="['/', language['LANGUAGE_CODE'], 'collection', 'productaddons', product | translate: 'slug']">
              {{product | translate : 'name'}}
            </a>
          </h4>
          
          <div class="product-rating" *ngIf="reviewsFeature$ | async">
            <h4 class="title">{{language['rating']}}</h4>
            <rating [(ngModel)]="rate" [max]="maxRate" [readonly]="true">
            </rating>
          </div>
          <!--End Product Rating-->
          <!--stock-->

          <div class="form-group">
            <label>{{language['total']}}: <span dir="ltr">{{ totalMalePrice / 100 | number}} {{currencyCode}}</span>
            </label>
          </div>
          <hr>
          <!--End Product-description-->
          <hr *ngIf="product.translations[language['LANGUAGE_CODE']]?.short_description">

          <form [formGroup]="AddonsForm" #ngForm="ngForm">
            <ng-container *ngFor="let add of Addons ; let v = index">
              <div class="form-check" *ngIf="!(add.variant.length === 1 && !add.optional)">
                <div class="product-name">
                  <h2 [ngClass]="{'title-alret': add && add.requiredSelectedAlert  }"  class="title">
                    {{add | translate: 'name'}}
                    <span class="title-validate" *ngIf="!add?.optional">({{language['required'] ||   'Required' }}
                      <label *ngIf="!add?.optional && add?.multipleSelect  && add.minimumChecks && add.minimumChecks > 0 ">
                        {{language['Choose'] ||   'Choose' }}  {{add.minimumChecks}}
                      </label>
                      <label *ngIf="!add?.optional && add?.multipleSelect  && add.maximumChecks && add.maximumChecks > 0 ">
                       -   {{language['max'] ||   'Max' }}  {{add.maximumChecks}}
                      </label>
                    )
                    </span>
                    <span class="title-validate" *ngIf="add?.optional">({{language['optional'] ||   'Optional' }}
                      <label *ngIf="add?.optional && add?.multipleSelect  && add.maximumChecks && add.maximumChecks > 0 ">
                        -   {{language['max'] ||   'Max' }} {{add.maximumChecks}}
                       </label>
                      )
                    </span>
                  </h2>
                </div>
                <div *ngFor="let a of AddonsForm?.get(add?.name)['controls']; let i = index">
                  <div [formArrayName]="add?.name">
                    <div [ngClass]="{'disabled-click': add && add.multipleSelect && add.requiredSelected && add.maximumChecks  && add.maximumChecks > 0 && add.requiredSelected == add.maximumChecks && !(add?.variant[i]['checked']) }" [ngSwitch]="add['type']">
                      <input class="input-addons" *ngSwitchCase="'radio'" [formControlName]="a[i]"
                        (change)="collectChooes(add?.variant[i] ,$event.target.checked ,v , add?.name , a[i] ,add?.optional, add?.multipleSelect)"
                        [value]="add?.variant[i]['checked']" [name]="add?.name" [id]="add?.variant[i].code"
                        [type]="add['type']" [checked]="add?.variant[i]['checked']">

                      <input  class="input-addons" *ngSwitchCase="'checkbox'" [formControlName]="a[i]"
                        (change)="collectChooes(add?.variant[i], $event.target.checked, v, add?.name, a[i], add?.optional, add?.multipleSelect )"
                        [value]="add?.variant[i]['checked']" [name]="add?.name" [id]="add?.variant[i].code"
                        [type]="add['type']" [checked]="add?.variant[i]['checked']">
                      <label [for]="add?.variant[i].code">
                        {{add?.variant[i].name}} <span dir="ltr" *ngIf="add?.variant[i]['price'] > 0">
                          (+{{add?.variant[i]['price']
                          / 100}} {{currencyCode}})</span>
                      </label>
                    </div>
                  </div>
                </div>
                <!-- <div class="invalid-feedback"
                  *ngIf="AddonsForm?.controls[add?.name].hasError('requireOneCheckboxToBeChecked')">
                  At least one checkbox is required to check</div> -->
              </div>
            </ng-container>
             
            <div *ngIf="!this.myStore.isContactUsInsteadAddCart; else elseBlock">
              <button class="custom-btn" [ngClass]="{'no-items-remaining':max==0}" (click)="addToCart()" *ngIf="!product.hidePrice"
              [disabled]="!canAddToCart || cartService.addedToCart.getValue() == false || max==0" role="button"
              aria-label="add to cart">
              {{
              max==0?language['noItemsRemaining']:
              variantUndefined ? language['unavailbleItem'] :
              (canAddToCart ? (cartService.addedToCart.getValue() !== false ? language['addToCart'] : language['wait'] )
              : language['outOfStock'])
              }}
            </button>

            </div>
            <ng-template #elseBlock>

              <button class="custom-btn" (click)="SwtichToContactUs()" *ngIf="product.hidePrice"
            
              aria-label="contactUS">
              {{
          language['contactUs']
              }}
            </button>
</ng-template>
          </form>
          <div class="product-action mt-3">
            <button class="custom-btn" (click)="downloadCatalogue()"
            [disabled]="!product['catalogPDF'] || product['catalogPDF'] == Null" role="button">
            Download product catalogue
          </button>
          </div>

        </div>
        <!--End product-details-content-->
      </div>
      <!--End Col-->
    </div>
    <!--End Row-->
    <!--start tabs of products-->
    <div class="singleProduct-tabs">
      <tabset>
        <tab class="description" [heading]="language['description']" *ngIf="product | translate: 'description'"
          [innerHTML]="product | translate: 'description' | noSanitizeHtml">
        </tab>
        <tab [heading]="language['specifications']" *ngIf="product.attributes?.length">
          <table id="attributes-table" class="table table-hover">
            <tr *ngFor="let attribute of product.attributes">
              <td>{{attribute | translate: 'name'}}</td>
              <td>
                <span *ngFor="let value of attribute.values; let last = last;">
                  {{value | translate: 'name'}}<ng-container *ngIf="!last">, </ng-container>
                </span>
              </td>
            </tr>
          </table>
        </tab>
        <tab [heading]="language['reviews']" *ngIf="reviewsFeature$ | async">
          <div class="product-reviews">
            <div class="review-item" *ngFor="let review of reviews$ | async">
              <div class="review-item-img">
                <img src="../../../assets/images/avatar.jpg" alt="user img">
              </div>
              <!--End Review-item-img-->
              <div class="review-item-content">
                <h2 class="user-name">
                  {{review.author?.firstName}} {{review.author?.lastName}}
                </h2>
                <span class="review-date">
                  {{review.createdAt | date: 'yyyy-MM-dd hh:mm'}}
                </span>
                <div class="review-rate">
                  <rating [(ngModel)]="review.rating" [max]="maxRate" [readonly]="true"></rating>
                </div>
                <div class="review-comment">
                  <h3 class="comment-title">{{review.title}}</h3>
                  <p>
                    {{review.comment}}
                  </p>
                </div>
              </div>
              <!--End review-item-content-->
            </div>
            <!--End review-item-->
          </div>
          <!--End Product-reviews-->
          <div class="review-form">
            <h3 class="title">
              {{language['add']}} {{language['rating']}}
            </h3>
            <div class="row">
              <div class="col-md-9">
                <form [formGroup]="reviewForm" (submit)="submitReview()">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <input class="form-control" placeholder="{{language['reviewTitle']}}*" formControlName="title">
                      </div>
                      <!--End form-group-->
                    </div>
                    <!--End col-->
                    <div class="col-md-6" [ngClass]="{'d-none': logged$ | async}">
                      <div class="form-group">
                        <input type="email" class="form-control" placeholder="{{language['email']}}*"
                          formControlName="email">
                      </div>
                      <!--End form-group-->
                    </div>
                    <!--End col-->
                    <div class="col-md-6 align-self-center">
                      <div class="form-group">
                        <span class="rate-label"> {{language['rating']}}</span>
                        <div class="rating">
                          <rating [max]="maxRate" (onLeave)="rateChange($event)"></rating>
                        </div>
                      </div>
                      <!--End form-group-->
                    </div>
                    <!--End col-->
                    <div class="col-md-12">
                      <div class="form-group">
                        <textarea class="form-control" placeholder="{{language['addYourcomment']}}*"
                          formControlName="comment"></textarea>
                      </div>
                      <!--End form-group-->
                    </div>
                    <!--End col-->
                    <div class="col-md-12">
                      <div class="form-group">
                        <button class="custom-btn add-review-btn" type="submit" [disabled]="reviewForm.invalid">
                          {{language['submit']}}
                        </button>
                      </div>
                      <!--End Form-group-->
                    </div>
                    <!--End col-->
                  </div>
                  <!--End Row-->
                </form>
              </div>
              <!--End col-->
              <div class="col-md-3 align-self-center">
                <div class="rate-container">
                  <div class="circle">{{rate | number: '1.1-1'}}</div>
                  <div class="stars-wrapper">
                    <rating [(ngModel)]="rate" [max]="maxRate" [readonly]="true"></rating>
                  </div>
                </div>
              </div>
              <!--Ebd col-->
            </div>
            <!--End row-->
          </div>
          <!--End Review-form-->
        </tab>
      </tabset>
    </div>
    <!--End Single-product-tabs-->
    <!--END tabs of products-->
  </div>
  <!--End Container-->
  <!-- *ngIf="associations?.associated_products.length > 0" -->

</section>
